import { Box, Button, LinearProgress, Typography, Chip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CustomSlider from 'components/CustomSlider';
import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useStyles } from './styles';

const ProgressAllSlider = ({
  courses = [],
  trails = [],
  onActionClickGoToTrail,
  onActionClickCourse,
  finishedTrailsAndCourses,
  slidesNumber,
  ...props
}) => {
  const { t } = useTranslation(['button', 'views']);
  const [slidesToShow, setSlidesToShow] = useState(4);
  const classes = useStyles();

  const allItems = useMemo(() => {
    const normalizedTrails = trails.map((t) => ({ ...t, type: 'trail' }));
    const normalizedCourses = courses.map((c) => ({ ...c, type: 'course' }));
    return [...normalizedTrails, ...normalizedCourses];
  }, [trails, courses]);

  const toFixed = (num, fixed = 0) => {
    fixed = Math.pow(10, fixed);
    return Math.floor(num * fixed) / fixed;
  };

  return (
    <CustomSlider
      itens={allItems}
      slidesNumber={slidesNumber}
      slidesToShow={slidesToShow}
      setSlidesToShow={setSlidesToShow}
      slideTeste={true}
      {...props}
    >
      {allItems?.map((item) => {
        const isTrail = item.type === 'trail';
        const progress = isTrail ? item.progress : item.course_progress;
        const name = item.name;
        const banner = item.banner || 'https://via.placeholder.com/350x208';
        const requiredCourseTrail = item.required_course || item.required_trail

        return (
          <div key={item.id} className={classes.slidesShow}>
            <Box
              className={classes.card}
              style={{ width: slidesToShow <= 2 ? 350 : 'unset' }}
            >
              <Box>
                <Link
                  onClick={() => {
                    if (isTrail && onActionClickGoToTrail) {
                      onActionClickGoToTrail(item.id, 'progress', item.id_course);
                    } else if (!isTrail && onActionClickCourse) {
                      onActionClickCourse(item);
                    }
                  }}
                >
                  <img className={classes.media} src={banner} alt={name} loading="lazy" decoding="async" />
                </Link>

                <Box className={classes.cardBody}>
                  <Box className={classes.cardBody}>
                    <Chip
                      label={isTrail ? 'Trilha' : 'Curso'}
                      color={isTrail ? 'secondary' : 'primary'}
                      size="small"
                      sx={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        fontWeight: 'bold',
                        backgroundColor: '#1976d2',
                        color: '#fff',
                      }}
                    />
                    {requiredCourseTrail && (
                       <Chip
                       label={'Obrigatório'}
                       size="small"
                       style={{
                         marginLeft: 2,
                         backgroundColor: '#E03838',
                         color: '#fff',
                       }}
                       sx={{
                         position: 'absolute',
                         top: 8,
                         left: 8,
                         fontWeight: 'bold',
                         color: '#fff',
                       }}
                     />
                    )}
                   
                  </Box>
                  <Typography component="span" className={classes.header}>
                    {name}
                  </Typography>
                  {!finishedTrailsAndCourses && (
                    <Box className={classes.progress}>
                      <Box className={classes.progressBar}>
                        <LinearProgress
                          style={{ width: '100%' }}
                          color="secondary"
                          variant="determinate"
                          value={toFixed(progress, 2)}
                        />
                      </Box>
                      <Box className={classes.progressText}>
                        <Typography component="span">
                          {progress && toFixed(progress, 0)}%
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  <Box className={classes.action}>
                    {isTrail ? (
                      <>
                        <Button
                          onClick={() => {
                            if (isTrail && onActionClickGoToTrail) {
                              onActionClickGoToTrail(item?.id, 'progress', item.id_course);
                            } else if (!isTrail && onActionClickCourse) {
                              onActionClickCourse(item);
                            }
                          }}
                          className={classes.actionButtonColor}
                          size="medium"
                        >
                          <InfoOutlinedIcon className={classes.actionIcon} />
                          {t('views:TrailRegistration.go_to_trail')}
                        </Button>
                        <Button
                          size="medium"
                          color="primary"
                          className={classes.actionButton}
                          onClick={() => {
                            if (isTrail && onActionClickGoToTrail) {
                              onActionClickGoToTrail(item.id, 'progress', item.id_course);
                            } else if (!isTrail && onActionClickCourse) {
                              onActionClickCourse(item);
                            }
                          }}                        >
                          {t(
                            `button:StudentContent.${finishedTrailsAndCourses ? 'btn_completed'
                              : progress > 0 ? 'btn_continue'
                                : 'btn_start'
                            }`
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          style={{ visibility: 'hidden' }}
                          onClick={() =>
                            onActionClickGoToTrail?.(item.id, 'progress', item.id_course)
                          }
                          className={classes.actionButtonColor}
                          size="medium"
                        >
                          <InfoOutlinedIcon className={classes.actionIcon} />
                          {t('views:TrailRegistration.go_to_trail')}
                        </Button>
                        <Button
                          size="medium"
                          color="primary"
                          className={classes.actionButton}
                          onClick={() => {
                            if (isTrail && onActionClickGoToTrail) {
                              onActionClickGoToTrail(item.id, 'progress', item.id_course);
                            } else if (!isTrail && onActionClickCourse) {
                              onActionClickCourse(item);
                            }
                          }}
                        >
                          {t(
                            `button:StudentContent.${finishedTrailsAndCourses ? 'btn_completed'
                              : progress > 0 ? 'btn_continue'
                                : 'btn_start'
                            }`
                          )}
                        </Button>
                      </>

                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </div>
        );
      })}
    </CustomSlider>
  );
};

export default ProgressAllSlider;
